<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索登錄賬號|名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加學校</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>

				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="學校編號" class="mb-0">
							<el-input size="small" v-model="from.school_no" placeholder="搜索學校編號"></el-input>
						</el-form-item>
						<el-form-item label="學校名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索學校名稱"></el-input>
						</el-form-item>
						
						<el-form-item label="特殊學校" class="mb-0">
							<el-select v-model="from.special" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="是" :value="1"></el-option>
								<el-option label="否" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="學校類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="男女校" :value="0"></el-option>
								<el-option label="男校" :value="2"></el-option>
								<el-option label="女校" :value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="地區">
							<el-select v-model="from.address_id" size="small"  placeholder="請選擇" style="width: 85%;">
								<el-option :key="-1" label="全部" :value="-1"></el-option>
								<el-option v-for="item in address_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>

				<el-table-column align="center" prop="id" label="ID">
				</el-table-column>

				<el-table-column align="center" prop="school_no" label="學校編號">
				</el-table-column>
				
				<el-table-column align="center" prop="name" label="學校名稱">
				</el-table-column>
				
				<el-table-column align="center" prop="address" label="學校地區">
				</el-table-column>
				<el-table-column align="center" prop="local" label="學校地址">
				</el-table-column>
				<el-table-column align="center" prop="phone" label="聯絡電話">
				</el-table-column>
				<el-table-column align="center" prop="rector" label="聯絡人名稱">
				</el-table-column>
				<el-table-column align="center" prop="internet" label="聯絡電郵">
				</el-table-column>
				
				<el-table-column align="center" prop="subject_name"  label="學校類型">
					<template slot-scope="v">
						<span>
							<el-tag  v-if="v.row.type == 0">男女校</el-tag>
							<el-tag type="success" v-if="v.row.type == 1">男校</el-tag>
							<el-tag type="warning" v-if="v.row.type == 2">女校</el-tag>
						</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="special" label="特殊學校">
					<template slot-scope="v">
						<span>
							<el-tag  v-if="v.row.special == 0">否</el-tag>
							<el-tag type="warning" v-else>是</el-tag>
						</span>
					</template>
				</el-table-column>
			
				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改學校' : '添加學校'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'120px'">
				<el-form-item label="學校名稱" prop="name">
					<el-input v-model="form.name" placeholder="學校名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="學校名稱(英文)" prop="name_en">
					<el-input v-model="form.name_en" placeholder="學校名稱(英文)" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="選擇地区" prop="address_id">
					<el-select v-model="form.address_id"   size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option label="請選擇" disabled :value="0"></el-option>
						<el-option v-for="item in address_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="地址" prop="local">
					<el-input type="textarea" :rows="2" v-model="form.local" 
					placeholder="地址" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="地址(英文)" prop="address_en">
					<el-input type="textarea" :rows="2" v-model="form.address_en" 
					placeholder="地址(英文)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="聯絡電話" prop="phone">
					<el-input v-model="form.phone" placeholder="聯絡電話" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="聯絡電郵" prop="internet">
					<el-input v-model="form.internet" placeholder="聯絡電郵" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="傳真" prop="fax">
					<el-input v-model="form.fax" placeholder="傳真" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="聯絡人名稱" prop="rector">
					<el-input v-model="form.rector" placeholder="聯絡人名稱" size="small" style="width: 85%;"></el-input>
				</el-form-item>	
				
				<el-form-item label="學校類型">
					<el-radio-group v-model="form.type" size="small">
						<el-radio :label="0" border>正常</el-radio>
						<el-radio :label="1" border>男校</el-radio>
						<el-radio :label="2" border>女校</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="特殊學校">
					<el-radio-group v-model="form.special" size="small">
						<el-radio :label="0" border>否</el-radio>
						<el-radio :label="1" border>是</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					school_no: '',
					type:-1,
					special:-1,
					address_id: -1,
				},
				auth_val: 'School',
				preUrl: "data/schoolAdminList", //列表地址
				delAllUrl: "data/delSchoolAdminAll", //批量删除地址
				delUrl: "data/delSchoolAdmin", //删除單条地址
				addUrl: "data/addSchoolAdmin", //添加/修改地址
				editStatusUrl:"data/editStatusSchoolAdmin",//修改狀態地址

				tableData: [],
				form: {
					id:0,
					name: "",
					name_en: '',
					phone:'',
					local:'',
					address_id:'',
					address_en:'',
					internet:'',
					fax:'',
					rector:'',
					type: 0,
					special: 0,
				},
				rules: {
					name: [{
							required: true,
							message: "學校名稱不能為空",
							trigger: 'blur',
						},
					],
					address_id: [{
							required: true,
							message: "請選擇地區",
							trigger: 'blur',
						},
					],
				},
				rule_list: [],
				address_list:[],
				check_img_list:[],

				prop: 'id',
				sort: 'descending',
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['address_list']);
		},
		methods: {
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: '兩次密碼輸入不一致',
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: "",
						name_en: '',
						phone:'',
						local:'',
						address_id:'',
						address_en:'',
						internet:'',
						fax:'',
						rector:'',
						type: 0,
						special: 0,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						name_en: e.row.name_en,
						phone:e.row.phone,
						local:e.row.local,
						address_id: e.row.address_id,
						address_en:e.row.address_en,
						internet:e.row.internet,
						fax: e.row.fax,
						rector: e.row.rector,
						type: e.row.type,
						special: e.row.special,
					}
				
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.address_list = all.data.list.address

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					school_no: '',
					type:-1,
					special:-1,
					address_id: -1,
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
